// import React, { useState } from "react";

// const FAQSection = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const faqs = [
//     {
//       question: "How do I save books offline?",
//       answer: "Go to the book page and tap 'Download' to make it available offline.",
//     },
//     {
//       question: "Why can’t I log in?",
//       answer: "Make sure your internet connection is active, and try resetting your password if needed.",
//     },
//     {
//       question: "How can I delete my account?",
//       answer: "You can delete your account from the Settings page under 'Account Management'.",
//     },
//     {
//       question: "Can I restore my purchased books?",
//       answer: "Yes, log in with the same account and your purchases will be restored automatically.",
//     },
//   ];

//   const toggleFAQ = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   const styles = {
//     section: {
//       marginTop: 40,
//       padding: "20px",
//       backgroundColor: "#f9fafb",
//       borderRadius: "10px",
//     },
//     question: {
//       cursor: "pointer",
//       fontWeight: "600",
//       fontSize: "1.1rem",
//       padding: "10px 0",
//       borderBottom: "1px solid #ddd",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     answer: {
//       padding: "10px 0 15px 10px",
//       color: "#555",
//       lineHeight: "1.5",
//     },
//   };

//   return (
//     <section style={styles.section}>
//       <h2>💡 Frequently Asked Questions</h2>
//       {faqs.map((faq, index) => (
//         <div key={index}>
//           <div style={styles.question} onClick={() => toggleFAQ(index)}>
//             {faq.question}
//             <span>{activeIndex === index ? "−" : "+"}</span>
//           </div>
//           {activeIndex === index && <p style={styles.answer}>{faq.answer}</p>}
//         </div>
//       ))}
//     </section>
//   );
// };

// export default FAQSection;


// import React, { useState } from "react";

// const FAQSection = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const faqs = [
//     {
//       question: "How do I save books offline?",
//       answer:
//         "1. Once you've purchase a book, you can download it to your device by tapping the 'Download' button on the book page.\n"
//         + "2. Or You can download all your books at once by tapping the 'Download All' button on the 'My Library' page..",
//       images: [
//          process.env.PUBLIC_URL + "/images/logo/BookEchoLogo.png",
//         // "/images/faq/download_step2.png",
//       ],
//     },
//     {
//       question: "Why can’t I log in?",
//       answer:
//         "Check your internet connection first. If that’s fine, try resetting your password. Still having trouble? Contact support via the Help section.",
//       images: ["/images/faq/login_error.png"],
//     },
//     {
//       question: "How can I delete my account?",
//       answer:
//         "Go to Settings → Account → Delete Account. Follow the confirmation steps to permanently remove your data.",
//       images: [
//         "/images/faq/delete_step1.png",
//         "/images/faq/delete_step2.png",
//         "/images/faq/delete_warning.png",
//       ],
//     },
//     {
//       question: "Can I restore my purchased books?",
//       answer:
//         "Yes! Simply log back in with the same account you used to make the purchase. All books will automatically reappear in your library.",
//       images: [],
//     },
//   ];

//   const toggleFAQ = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   const styles = {
//     section: {
//       marginTop: 40,
//       padding: "20px",
//       backgroundColor: "#f9fafb",
//       borderRadius: "10px",
//     },
//     question: {
//       cursor: "pointer",
//       fontWeight: "600",
//       fontSize: "1.1rem",
//       padding: "10px 0",
//       borderBottom: "1px solid #ddd",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     answer: {
//       padding: "10px 0 15px 10px",
//       color: "#555",
//       lineHeight: "1.5",
//     },
//     imageContainer: {
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "10px",
//       marginTop: "10px",
//     },
//     image: {
//       width: "120px",
//       height: "auto",
//       borderRadius: "8px",
//       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//     },
//   };

//   return (
//     <section style={styles.section}>
//       <h2>💡 Frequently Asked Questions</h2>
//       {faqs.map((faq, index) => (
//         <div key={index}>
//           <div style={styles.question} onClick={() => toggleFAQ(index)}>
//             {faq.question}
//             <span>{activeIndex === index ? "−" : "+"}</span>
//           </div>

//           {activeIndex === index && (
//             <div style={styles.answer}>
//               <p>{faq.answer}</p>
//               {faq.images.length > 0 && (
//                 <div style={styles.imageContainer}>
//                   {faq.images.map((img, i) => (
//                     <img key={i} src={img} alt={`FAQ step ${i + 1}`} style={styles.image} />
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       ))}
//     </section>
//   );
// };

import React, { useState } from "react";
import FAQItem from "./FAQItem";

// const FAQSection = ({ faqs }) => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const toggle = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <section style={{ marginTop: "30px" }}>
//       <h2>💡 Frequently Asked Questions</h2>
//       {faqs.map((faq, i) => (
//         <div key={i}>
//           <div
//             style={{
//               cursor: "pointer",
//               fontWeight: 600,
//               display: "flex",
//               justifyContent: "space-between",
//               marginBottom: "5px",
//             }}
//             onClick={() => toggle(i)}
//           >
//             {faq.question} <span>{activeIndex === i ? "−" : "+"}</span>
//           </div>

//           {activeIndex === i && <FAQItem faq={faq} />}
//         </div>
//       ))}
//     </section>
//   );
// };

const FAQSection = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section style={{ marginTop: "30px" }}>
      <h2>💡 Frequently Asked Questions</h2>
      {faqs.map((faq, i) => (
        <div key={i} style={{ marginBottom: "10px" }}>
          {/* Top-level question */}
          <div
            style={{
              cursor: "pointer",
              fontWeight: 600,
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#f4f4f4",
              padding: "8px 10px",
              borderRadius: "6px",
            }}
            onClick={() => toggle(i)}
          >
            {faq.question}
            <span>{activeIndex === i ? "−" : "+"}</span>
          </div>

          {/* Show content only when expanded */}
          {activeIndex === i && (
            <FAQItem faq={faq} level={1} />
          )}
        </div>
      ))}
    </section>
  );
};

export default FAQSection;
